import React, { useState, useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import Button from "@atlaskit/button/new";
import { setEditorSaved } from "../../../../../../redux/actions/integrationActions";
import { useDispatch } from "react-redux";
import { Label } from "@atlaskit/form";

import ShowFullScopeVariablePathHint from "../../extension/ShowFullScopeVariablePathHint";

const IteratorInput = ({ action }) => {
  const [value, setValue] = useState("");
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (action?.iterator) {
      setValue(action.iterator);
    } else {
      setValue("");
    }
  }, [action]);

  const changeValue = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    // Only validate non-empty input.
    if (newValue && !newValue.startsWith("$")) {
      setError("The JSON path must start with '$'");
    } else {
      setError(null); // clear the error
    }
    action.iterator = newValue;
    dispatch(setEditorSaved(false));
  };

  const clearValue = () => {
    setValue("");
    setError(null);
    action.iterator = "";
    dispatch(setEditorSaved(false));
  };

  return (
    <>
      <p className="ihub-action-tab-description">
        An iterator allows you to navigate through a list of items in the response data using a JSON path. It applies the action to each item in the
        list one by one.
        <br />
        <strong>Provide a valid JSON path starting with '$'.</strong> For example, to iterate over a flat array response from the parent use:{" "}
        <code>$.payload._values</code>.
      </p>
      <ShowFullScopeVariablePathHint />
      <Label>JSON Path to the array of items:</Label>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div style={{ flex: 1 }}>
          <Textfield value={value} isCompact onChange={changeValue} />
        </div>
        <Button appearance="subtle" spacing="compact" onClick={clearValue} isDisabled={!value}>
          Clear
        </Button>
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <p>
        Use <code>$</code> to refer to the complete response from the parent, e.g., <code>$.payload._values</code>.
      </p>
      <p>Examples:</p>
      <ul>
        <li>
          <code>$.payload._values</code> – Use this clause to iterate over the response when its a flat array response
        </li>
        <li>
          <code>$.issue.fields.attachment</code> – Iterates over an array of attachments within the payload.
        </li>
      </ul>
    </>
  );
};

export default IteratorInput;
